// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"6eb9a52b","74":"d96e1bd2","216":"a835c7d5"}[chunkId] + ".chunk.js";
};